import config from ':cloud/config';
import useHasExperiment from ':cloud/hooks/useHasExperiment';

export function useIsPayAsYouGoEnabled() {
  const isProd = config.isProduction();
  return useHasExperiment('apr_2024_pay_as_you_go', 'treatment') || !isProd;
}
